import { z } from 'zod'

export const STRATALYST_RESPONDENT_REPORT_CONTRACT_VERSION = '1.0.0' as const
const passthroughResponseSchema = z.unknown()

export const stratalystRespondentMapListResponseSchema = passthroughResponseSchema
export const stratalystRespondentMapCreateResponseSchema = passthroughResponseSchema
export const stratalystProjectRespondentsListResponseSchema = passthroughResponseSchema
export const stratalystResponsesListResponseSchema = passthroughResponseSchema
export const stratalystResponseCreateResponseSchema = passthroughResponseSchema
export const stratalystAiAnalysisListResponseSchema = passthroughResponseSchema
export const stratalystAiAnalysisCreateResponseSchema = passthroughResponseSchema
export const stratalystAiAnalysisPartListResponseSchema = passthroughResponseSchema
export const stratalystPublishReportResponseSchema = passthroughResponseSchema

export type StratalystRespondentMapListResponse = z.infer<typeof stratalystRespondentMapListResponseSchema>
export type StratalystRespondentMapCreateResponse = z.infer<typeof stratalystRespondentMapCreateResponseSchema>
export type StratalystProjectRespondentsListResponse = z.infer<typeof stratalystProjectRespondentsListResponseSchema>
export type StratalystResponsesListResponse = z.infer<typeof stratalystResponsesListResponseSchema>
export type StratalystResponseCreateResponse = z.infer<typeof stratalystResponseCreateResponseSchema>
export type StratalystAiAnalysisListResponse = z.infer<typeof stratalystAiAnalysisListResponseSchema>
export type StratalystAiAnalysisCreateResponse = z.infer<typeof stratalystAiAnalysisCreateResponseSchema>
export type StratalystAiAnalysisPartListResponse = z.infer<typeof stratalystAiAnalysisPartListResponseSchema>
export type StratalystPublishReportResponse = z.infer<typeof stratalystPublishReportResponseSchema>
